<template>
    <div class="content">
        <div class="geodis-article-header">
            <div class="geodis-article-header__content">
                <div class="container-fluid">
                    <div class="local-task"></div>
                    <h1 class="title__style-1 text-left underline-auto animation-played">
                        <span class="title-inner"
                            ><span class="geodis_blue_color">{{ $t('footer.legalMentions') }}</span></span
                        >

                        <div class="underline" style="left: 47.4669px; width: 118.543px"></div>
                    </h1>
                    <br /><br />
                    <div class="field field--name-field-description field--type-text-long field--label-hidden field--item">
                        <p>
                            <strong>{{ $t('footer.legalMentionsContent.geodisSA') }}</strong
                            >{{ $t('footer.legalMentionsContent.desc1') }}<strong>« GEODIS »</strong>
                        </p>
                        <p>
                            <strong>{{ $t('footer.legalMentionsContent.registeredOffice') }}</strong> :
                        </p>
                        <p>« Espace Seine »</p>
                        <p>26 quai Charles Pasqua</p>
                        <p>92300 LEVALLOIS-PERRET</p>
                        <p>France</p>
                        <p>
                            <strong>{{ $t('footer.legalMentionsContent.phone') }}</strong> : + 33 (0)1 56 76 26 00
                        </p>
                        <p>
                            <strong>{{ $t('footer.legalMentionsContent.contact') }}</strong> :
                            <a href="mailto:webmaster@geodis.com">webmaster@geodis.com</a>
                        </p>
                        <p>
                            <strong>{{ $t('footer.legalMentionsContent.identity') }}</strong>
                            : Philippe de Carne, {{ $t('footer.legalMentionsContent.businessDev') }}
                        </p>
                        <p>
                            <strong>{{ $t('footer.legalMentionsContent.host') }}</strong> :
                        </p>
                        <p>GEODIS</p>
                        <p>
                            <strong>{{ $t('footer.legalMentionsContent.graphicDesigner') }} </strong>
                            :
                        </p>
                        <p>GEODIS, Meritis.</p>
                    </div>
                    <div class="arrow-down arrow-down__style-1"></div>
                </div>
            </div>
        </div>
        <div class="geodis-article-content arrow-down-target">
            <div class="geodis-article-content__inner">
                <h3 class="title title__style-3 body-title text-left underline-auto animation-played" style="">
                    <div class="title-inner"></div>
                    <div class="underline" style="left: 0px; width: 0px"></div>
                </h3>
                <div class="panel-group accordion-style-1" id="shp-main-accordion"></div>
                <div
                    property="schema:text"
                    class="field field--name-body field--type-text-with-summary field--label-hidden field--item"
                >
                    <h2 align="center">
                        <span class="geodis_blue_color">{{ $t('footer.legalMentionsContent.condition') }}</span>
                    </h2>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.definition') }}</strong></span
                        >
                    </h4>
                    <p>
                        {{ $t('footer.legalMentionsContent.definition1') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.definition2') }}
                        <router-link to="/informations/privacyPolicy"
                            ><span class="blue-geodis">{{ $t('footer.privacyPolicy') }}</span></router-link
                        >
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.definition3') }}
                    </p>
                    <p>{{ $t('footer.legalMentionsContent.definition4') }}</p>
                    <p>
                        {{ $t('footer.legalMentionsContent.definition5') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.definition6') }}
                        <router-link to="/"
                            ><span class="blue-geodis"
                                >{{ window.location.protocol }}//{{ window.location.hostname }}</span
                            ></router-link
                        >
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.preamble') }}</strong></span
                        >
                    </h4>
                    <p>
                        {{ $t('footer.legalMentionsContent.preamble1') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.preamble2') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.preamble3') }}
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.siteObject') }}</strong></span
                        >
                    </h4>
                    <p>
                        {{ $t('footer.legalMentionsContent.siteObject1') }}
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.siteObject2') }}</strong></span
                        >
                    </h4>
                    <p>{{ $t('footer.legalMentionsContent.siteObject3') }}</p>
                    <p>
                        {{ $t('footer.legalMentionsContent.siteObject4') }}
                    </p>
                    <p>{{ $t('footer.legalMentionsContent.siteObject5') }}</p>
                    <p>
                        {{ $t('footer.legalMentionsContent.siteObject6') }}
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.intellectProperty') }}</strong></span
                        >
                    </h4>
                    <p>
                        {{ $t('footer.legalMentionsContent.intellectProperty1') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.intellectProperty2') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.intellectProperty3') }}
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.confidentiality') }}</strong></span
                        >
                    </h4>
                    <p>
                        {{ $t('footer.legalMentionsContent.confidentiality1') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.confidentiality2') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.confidentiality3') }}
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.hypertext') }}</strong></span
                        >
                    </h4>
                    <p>
                        {{ $t('footer.legalMentionsContent.hypertext1') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.hypertext2') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.hypertext3') }}
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.responsability') }}</strong></span
                        >
                    </h4>
                    <p>
                        {{ $t('footer.legalMentionsContent.responsability1') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.responsability2') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.responsability3') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.responsability4') }}
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.applicableRight') }}</strong></span
                        >
                    </h4>
                    <p>
                        {{ $t('footer.legalMentionsContent.applicableRight1') }}
                    </p>
                    <p>
                        {{ $t('footer.legalMentionsContent.applicableRight2') }}
                    </p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.credits') }}</strong></span
                        >
                    </h4>
                    <p>{{ $t('footer.legalMentionsContent.developedBy') }}</p>
                    <p>Meritis</p>
                    <p>5 – 7, rue d’Athènes,</p>
                    <p>75009 Paris</p>
                    <p>France</p>
                    <h4>
                        <span class="geodis_blue_color"
                            ><strong>{{ $t('footer.legalMentionsContent.technologies') }}</strong></span
                        >
                    </h4>
                    <p>{{ $t('footer.legalMentionsContent.stackTech') }} vuejs / nodejs / mongoDB.</p>
                    <p>{{ $t('footer.legalMentionsContent.docsPdf') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            component: null,
            window: window
        };
    },
    computed: {},
    methods: {},
    mounted() {},
    watch: {}
};
</script>

<style lang="scss" scoped>
.spacer {
    height: 30px;
}
</style>
